export const selectBusinessStripeFoldoutOpen = ($) => $.ui?.stripeBusinessFoldoutOpen;
export const selectStripeFoldoutOpen = ($) => $.ui?.stripeFoldoutOpen;
export const selectTipsFoldoutOpen = ($) => $.ui?.tipsFoldoutOpen;
export const selectPolicyFoldoutOpen = ($) => $.ui?.policyFoldoutOpen;
export const selectPolicyFocusNote = ($) => $.ui?.policyFocusNote;
export const selectVoucherPanelOpen = ($) => $.ui?.voucherPanelOpen;
